<template>
  <div>
    <h1>{{ name }}</h1>
    <span v-if="address">{{ address }}</span>
    <span v-if="postalCode || city">
      <br />
      <span v-if="postalCode">{{ postalCode }}</span>
      <span v-if="city">{{ city }}</span>
    </span>
    <span v-if="phone">
      <br />Tel:
      <a :href="'tel:' + phone">{{ phone }}</a>
    </span>
    <span v-if="fax">
      <br />Fax:
      <a :href="'fax:' + fax">{{ fax }}</a>
    </span>
    <span v-if="mail">
      <br />Mail:
      <a :href="'mailto:' + mail">{{ mail }}</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'app-footer-city',
  props: {
    configuration: Object
  },
  computed: {
    address () {
      return this.configuration.cityAddress
    },
    postalCode () {
      return this.configuration.cityPostalCode
    },
    city () {
      return this.configuration.cityCity
    },
    phone () {
      return this.configuration.cityPhone
    },
    fax () {
      return this.configuration.cityFax
    },
    mail () {
      return this.configuration.cityMail
    },
    name () {
      return this.configuration.cityName
    }
  }
}
</script>

<style scoped>
  h1 {
    font-weight: 700;
    font-size: 1.4rem;
    letter-spacing: normal;
  }

  a {
    color: rgba(255, 255, 255, 0.8);
    font-weight: normal;
    transition: all 0.3s ease;
  }

  a:hover {
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/app-footer-city-information.vue